"use strict";

exports.__esModule = true;
exports.MeasureChartThumbnail = MeasureChartThumbnail;
var _react = _interopRequireDefault(require("react"));
var _ScatterPlotThumbnail = require("../../Thumbnails/ScatterPlotThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Thumbnail for MetricChartWidget.
 */
function MeasureChartThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    _props$color = props.color,
    color = _props$color === void 0 ? "red" : _props$color;
  return /*#__PURE__*/_react["default"].createElement(_ScatterPlotThumbnail.ScatterPlotThumbnail, _extends({}, props, {
    x: x,
    y: y,
    color: color
  }));
}